import { useMemo } from 'react'
import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { FilePlus2, KanbanSquare } from 'lucide-react'
import { PageHeader } from '@/components/page-header'
import { Button } from '@/components/ui/button'
import { LoanList } from '@/features/loans/loan-list'
import { usePermission } from '@/lib/permissions'
import { requirePermission } from '@/lib/route-guards'
import { ROUTES } from '@/lib/routes'
import { useShortcuts, type ShortcutDef } from '@/lib/shortcuts'

export const Route = createFileRoute('/_app/loans/')({
  beforeLoad: requirePermission('loans:read'),
  component: LoansIndexPage,
})

/** Cartera de préstamos por etapa. */
function LoansIndexPage() {
  const navigate = useNavigate()
  const canOriginate = usePermission('loans:originate')
  const shortcuts = useMemo<ShortcutDef[]>(
    () =>
      canOriginate
        ? [{ id: 'loan-new', group: 'Acciones', keys: ['N'], sequence: ['n'], label: 'Nueva solicitud', run: () => void navigate({ to: ROUTES.newLoan }) }]
        : [],
    [canOriginate, navigate],
  )
  useShortcuts(shortcuts)

  return (
    <div className="space-y-6">
      <PageHeader
        title="Cartera"
        description="Préstamos en trámite, vigentes y cerrados, con saldo, atraso y próxima cuota."
        actions={
          <>
            <Button variant="outline" onClick={() => void navigate({ to: ROUTES.pipeline })}>
              <KanbanSquare /> Tablero
            </Button>
            {canOriginate && (
              <Button onClick={() => void navigate({ to: ROUTES.newLoan })}>
                <FilePlus2 /> Nueva solicitud
              </Button>
            )}
          </>
        }
      />
      <LoanList />
    </div>
  )
}
